import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import { every } from 'lodash'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { HelpLink, Spinner } from '../../../../components/generic'
import HandoverPdfExport from '../../../../components/pdf/HandoverPdfExport'
import HandoverHoursFilter from './HandoverHoursFilter'
import HandoverNotes from './HandoverNotes'
import HandoverResidentItem from './HandoverResidentItem'

export default class CurrentHandover extends Component {
  isEmpty = (logsByResident, notes) => {
    const hasNoVisibleLogs = (group) => !group.logs.length
    return (
      (!logsByResident.length || every(logsByResident, hasNoVisibleLogs)) &&
      !notes.length
    )
  }

  renderData() {
    const { logsByResident, notes } = this.props
    const isDesktopStyles = isBrowser || isTablet
    if (!logsByResident && !notes) return <Spinner />
    if (this.isEmpty(logsByResident, notes)) {
      return (
        <div style={styles.emptyContainer}>
          <EmptyState
            title="Shoot... No data to show you"
            icon={<NoDataIcon />}
          />
          <HelpLink supportLink={SUPPORT_ARTICLE} style={styles.supportLink} />
        </div>
      )
    }

    const filteredLogsByResident = logsByResident.map((entry) => {
      const filteredLogs = entry.logs.map((log) => {
        if (log.deleted) {
          return {
            ...log,
            description: '',
            title: 'Log Removed'
          }
        }
        return { ...log }
      })
      return { ...entry, logs: filteredLogs }
    })

    return (
      <div>
        <div
          style={{
            ...styles.dataContainer,
            flexDirection: isDesktopStyles ? 'row' : 'column'
          }}
        >
          <div style={isDesktopStyles ? styles.leftContainer : null}>
            {logsByResident.map((logGroup, i) => (
              <div key={i}>
                <HandoverResidentItem data={logGroup} />
              </div>
            ))}
          </div>
          <div style={isDesktopStyles ? styles.rightContainer : null}>
            {isBrowser ? (
              <div style={styles.exportContainer}>
                <HandoverPdfExport
                  handover={{
                    logsByResident: filteredLogsByResident,
                    notes
                  }}
                  title={PDF_TITLE}
                />
              </div>
            ) : null}
            <HandoverNotes notes={notes} />
          </div>
        </div>
        <HelpLink supportLink={SUPPORT_ARTICLE} style={styles.supportLink} />
      </div>
    )
  }

  render() {
    const { hasRecentHandover, hoursVisible, setHoursVisible } = this.props
    return (
      <div>
        <div style={styles.headingContainer}>
          <h2 style={styles.heading}>Handover logs</h2>
          <div style={styles.filterContainer}>
            <HandoverHoursFilter
              hasRecentHandover={hasRecentHandover}
              hoursVisible={hoursVisible}
              setHoursVisible={setHoursVisible}
              style={styles.filter}
            />
          </div>
        </div>
        {this.renderData()}
      </div>
    )
  }
}

const PDF_TITLE = `Handover - ${dayjs().format('DD MMM YYYY')}`
const SUPPORT_ARTICLE =
  'https://support.logmycare.co.uk/pro-module/handovers/how-do-handovers-work'

const styles = {
  clickableFiller: {
    cursor: 'pointer',
    flex: 1
  },
  dataContainer: {
    display: 'flex',
    width: '100%'
  },
  divider: {
    height: 2,
    marginBottom: 22,
    width: '100%'
  },
  emptyContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  exportContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 20
  },
  filterContainer: {
    alignSelf: 'flex-end',
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    marginLeft: 20
  },
  heading: {
    marginBottom: '0.3em',
    // fontWeight: 300,
    textOverflow: 'ellipsis',
    hyphens: 'auto',
    marginRight: 20
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  leftContainer: {
    width: '60%',
    paddingRight: 20
  },
  rightContainer: {
    width: '40%',
    flex: '1'
  },
  supportLink: {
    marginTop: 12
  }
}

CurrentHandover.propTypes = {
  hasRecentHandover: PropTypes.bool.isRequired,
  hoursVisible: PropTypes.number,
  logsByResident: PropTypes.array,
  notes: PropTypes.array,
  setHoursVisible: PropTypes.func.isRequired
}
